{
  "ru": {
    "title": "Номер документа",
    "passport": {
      "title": "Номер паспорта",
      "description": "Находится на лицевой стороне в правом верхнем углу. Заполняется вместе с буквой"
    },
    "id": {
      "title": "Номер удостоверения",
      "description": "Находится на обратной стороне в правом верхнем углу"
    },
    "close": "Закрыть"
  },
  "kk": {
    "title": "Құжат нөмірі",
    "passport": {
      "title": "Паспорт нөмірі",
      "description": "Паспорттың алдыңғы жағының жоғарғы оң жақ бұрышында орналасқан. Бірінші әрпімен бірге жазылады"
    },
    "id": {
      "title": "Жеке куәлік нөмірі",
      "description": "Жеке куәліктің артқы жағының жоғарғы оң жақ бұрышында орналасқан"
    },
    "close": "Жабу"
  },
  "en": {
    "title": "Document number",
    "passport": {
      "title": "Passport number",
      "description": "Located on the front right corner of the passport"
    },
    "id": {
      "title": "ID number",
      "description": "Located on the back right corner of the ID"
    },
    "close": "Close"
  }
}
